import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { RequireAccess } from '../../parts/RequireAccess';
import { quickNavLinks } from '../../parts/quickNavLinks';
import { ProgressGraph } from './ProgressGraph/ProgressGraph';
import { InvoiceStatusGraph } from './InvoiceStatusGraph/InvoiceStatusGraph';

/**
 * Top-level dashboard page.
 *
 * Renders invoice status graphs for the current and previous months via {@link ProgressGraph}
 * and {@link InvoiceStatusGraph}, followed by a quick-access navigation list built from
 * {@link quickNavLinks} (respects per-link access control via `RequireAccess`).
 *
 * Authenticated users are automatically redirected here from `/` and `/login`.
 */
export const DashboardContainer = () => (
  <Container>
    <h1>Dashboard</h1>
    <ProgressGraph>
      <InvoiceStatusGraph label="This Month" monthsAgo={0} />
      <InvoiceStatusGraph label="Last Month" monthsAgo={1} />
    </ProgressGraph>
    <ul>
      {
        quickNavLinks.map((link) => (
          <RequireAccess to={link.toLink} key={link.toLink}>
            <li>
              <Link to={link.toLink}>
                <div style={{ padding: '15px', margin: '5px', backgroundColor: 'rgba(233, 233, 233, 1)' }}>
                  {link.label}
                </div>
              </Link>
            </li>
          </RequireAccess>
        ))
      }
    </ul>
  </Container>
);
